var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgQuotes = function SvgQuotes(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 1S6 1 3 4s-3 8-3 8v10h10V12H5s0-2.5 1.5-4.5S10 5 10 5V1zm14 0s-4 0-7 3-3 8-3 8v10h10V12h-5s0-2.5 1.5-4.5S24 5 24 5V1z",
    fill: "currentColor"
  })));
};
export { SvgQuotes as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTEwIDFTNiAxIDMgNHMtMyA4LTMgOHYxMGgxMFYxMkg1czAtMi41IDEuNS00LjVTMTAgNSAxMCA1VjF6bTE0IDBzLTQgMC03IDMtMyA4LTMgOHYxMGgxMFYxMmgtNXMwLTIuNSAxLjUtNC41UzI0IDUgMjQgNVYxeiIgZmlsbD0iY3VycmVudENvbG9yIi8+PC9zdmc+";